import * as Highcharts from 'highcharts/highcharts';
import HighchartsMore from 'highcharts/highcharts-more';
import BrokenAxis from 'highcharts/modules/broken-axis';

$(function () {
    HighchartsMore(Highcharts);
    BrokenAxis(Highcharts);

    const defaultOptions = {
        chart: {
            style: {
                fontFamily: '"Roboto", Helvetica, Arial, sans-serif'
            }
        },
        xAxis: {
            labels: {
                useHTML: true
            }
        },
        yAxis: {
            title: {
                // Disable title
                text: <string>null
            },
            labels: {
                useHTML: true
            }
        },
        plotOptions: {
            series: {
                animation: false // Avoid problems with PDF
            }
        },
        title: {
            text: <string>null
        },
        legend: {
            enabled: false
        },
        tooltip: {
            enabled: false
        },
        credits: {
            enabled: false
        },
        exporting: {
            enabled: false
        }
    };
    Highcharts.setOptions(defaultOptions);
    // Workaround CSP violation: https://github.com/highcharts/highcharts/issues/6173#issuecomment-276905452
    // noinspection JSUnusedGlobalSymbols
    Highcharts.Tooltip.prototype.applyFilter = function () {};
    // Override error handling in order to throw all errors
    Highcharts.error = function (code) {
        throw 'Highcharts error #' + code + ': www.highcharts.com/errors/' + code;
    };
});
export default Highcharts;